import 'reflect-metadata';
import { Service } from 'typedi';
import type { PaginationTypeStrategyData } from '../../types/pagination-strategy-data.type';
import { StrategyBuilder } from '../../StrategyBuilder';
import { PaginationStrategyService } from '../../PaginationStrategyService';

@Service({ id: 'searchPaginationQdsStrategyService' })
export class SearchPaginationQdsStrategyBuilder extends StrategyBuilder<PaginationStrategyService> {
  build(details: PaginationTypeStrategyData): PaginationStrategyService {
      return new SearchPaginationQdsStrategyService(details);
  }
}

export class SearchPaginationQdsStrategyService extends PaginationStrategyService {
  details;
  constructor(details: PaginationTypeStrategyData) {
      super();
      this.details = details;
  }

  makePagination(): string {
      return 'uiaas-qds-pagination';
  }

  getPaginationProps(params: Record<string, string>): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
